import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import { Prop, Watch } from 'vue-property-decorator';
@Component({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currEffect:{
      default:'静态'
    },
    effectList:{
      type:Array
    }
  },
  components: {
  },
  watch: {
    visible: {
      handler(val) {
        this.show = val
      },
      immediate: true
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class EffectPopup extends Vue{
  @Prop({default: '静态'})
  currEffect: string
  state = new PageState();
  imgIcons={
    '静态':require('/public/images/video_editor/static_effect.png'),
    '微动':require('/public/images/video_editor/inching_effect.png'),
    '动画':require('/public/images/video_editor/animation_effect.png'),
    '天气特效':require('/public/images/video_editor/weather_effect.png'),
  };
  chooseEffect = '静态' ;
  show = false;
  // effectList = [{idx:0,value:'静态',imgIcon:require('/public/images/video_editor/static_effect.png')},{idx:1,value:'微动',imgIcon:require('/public/images/video_editor/inching_effect.png')},{idx:2,value:'动画',imgIcon:require('/public/images/video_editor/animation_effect.png')}];
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  @Watch("currEffect")
  listenCurrEffect(val) {
    if (val) {
      this.chooseEffect = val;
    }
  }
  closePopup() {
    this.$emit('close')
  }
  /**
   * 确定
   */
  confirmSubtitle() {
    this.$emit('close')
  }
  submitRate(){
    this.$emit('changeEffect',this.chooseEffect)
    this.$emit('close')
  }
}